import { useLocation } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { getStaticTitle } from "@/lib/page-titles";

export function PageTitle() {
  const { pathname } = useLocation();
  useDocumentTitle(getStaticTitle(pathname));
  return null;
}
